<template>
  <div class="featured-product-card">
    <ProductCard :product="product" class="product-card" :media="media" />
  </div>
</template>

<script>
import ProductCard from "@/components/ProductCard.vue";

export default {
  name: "FeaturedProductCard",
  components: {
    ProductCard,
  },
  props: {
    media: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.featured-product-card {
  :deep() {
    .card {
      .media-anchor {
        aspect-ratio: 4 / 5;

        img,
        video {
          aspect-ratio: 4 / 5;
        }
      }
    }
  }
}
</style>
